export default function DividerLine({customStyle}) {
	return <div className={'divider-line'} style={customStyle?customStyle:null}>
		<div className={'divider-line-inner'} style={customStyle&&customStyle.color?{background:customStyle.color}:null}/>
	</div>
}